import React from 'react';
import { Row, Col, Typography, Card } from 'antd';
import ArrowButton from '../../../shared/ArrowButton';
import IconCard from '../../../shared/IconCard';

import WhiteStar from '../../../assets/white-star.svg';
import YellowStar from '../../../assets/star.svg';
import '../../../assets/vertical-frame.svg';
import './PricingPlans.css';
import {
  useNavigate,
} from "react-router-dom";
import { getIcon, ICONS } from '../../../icons';

const { Title } = Typography;

const PricingPlans = () => { 
  const navigate = useNavigate();
  return (
    <div className="pricing-wrapper">
      <Title level={2} className="title-over-frame">Pick Your Play. Level Up Your Club.</Title>

      <Row gutter={[24, 24]} justify="center" className="plan-row">
        <Col xs={24} md={6}>
          <IconCard
            title="Free"
            description={<>Perfect for small clubs getting started—simple, smart, and totally free.<br /><strong>10 members included at no cost.</strong></>}
            icon={ getIcon(ICONS.STAR, true, { size : 30 } ) }
            variant="light"
          />
        </Col>

        <Col xs={24} md={6}>
          <IconCard
            title="Standard"
            description={<>Designed for growing teams—start accepting payments and manage more players with ease.<br /><strong>£4 a month, 25 members included.</strong></>}
            icon={ getIcon(ICONS.STAR, false, { size : 30 , secondary: 'orange' } ) }
            variant="dark"
          />
        </Col>

        <Col xs={24} md={6}>
          <IconCard
            title="Pro"
            description="For thriving clubs—automate payments, manage more members, and scale without the stress."
            icon={ getIcon(ICONS.STAR, true, { size : 30 } ) }
            variant="light"
          />
        </Col>
      </Row>
      <p className="home-plan-allowances">Existing bolt-ons can add features or raise capacity, including 150 members. These are plan allowances, not a product limit. The ongoing Free plan is separate from the seven-day test club.</p>
      <div className="pricing-cta">
        <ArrowButton
          onClick={ () => { 
            navigate("/pricing")
            document.getElementById('root').scrollTo(0, 0);
          }}
        >View Detailed Pricing</ArrowButton>
      </div>
    </div>
  );
}

export default PricingPlans;
